import { Edit } from "@mui/icons-material";
import React from "react";

const FileTypeAnswer = ({ files, type, onEdit, survey_theme }) => {
  return (
    <div
      className={`mt-2 ${files?.length > 3 ? "answerImage" : "d-flex gap-2"}`}
    >
      {files?.map((image, index) => {
        return (
          <div
            key={index}
            style={{
              position: "relative",
              width: "75px",
              height: "75px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              overflow: "hidden",
              backgroundColor: "#f8f9fa",
            }}
          >
            {image instanceof File ? (
              image.type.startsWith("video/") ? (
                <video
                  controls
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                >
                  <source src={URL.createObjectURL(image)} type="video/mp4" />
                </video>
              ) : image.type.startsWith("image/") ? (
                <img
                  src={URL.createObjectURL(image)}
                  alt={`file-${index}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    fontSize: "10px",
                    textAlign: "center",
                    overflow: "hidden",
                  }}
                >
                  <span style={{ fontSize: "24px" }}>📄</span>
                  <span
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: "65px",
                    }}
                  >
                    {image.name}
                  </span>
                </div>
              )
            ) : null}
            {type === "file" && (
              <div
                style={{
                  position: "absolute",
                  top: "0",
                  right: "0",
                  display: "flex",
                  flexDirection: "row",
                  gap: "2px",
                  zIndex: 10,
                  padding: "2px",
                  border: 0,
                }}
              >
                <div
                  onClick={() => onEdit?.(image, index)}
                  style={{
                    cursor: "pointer",
                    background: "rgba(255, 255, 255, 0.95)",
                    width: "20px",
                    height: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Edit
                    style={{
                      fontSize: "14px",
                      color: survey_theme?.primaryColor,
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
export default FileTypeAnswer;
